import { useEffect, useState, useCallback } from 'react'
import { useSessionContext } from '../contexts/SessionContext'
import { logger } from '../utils/helpers/logger'
import { AgamiSpot } from '../types/supabase'
import { getSpotsByExperienceId } from '../utils/helpers/user-spot.helpers'

interface UseUserAgamiListByExperienceOpts {
  experienceId?: string
  enabled?: boolean
}

export const useUserAgamiListByExperience = (options: UseUserAgamiListByExperienceOpts) => {
  const { experienceId, enabled = true } = options
  const { user } = useSessionContext()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [agamiList, setAgamiList] = useState<AgamiSpot[]>([])

  const fetchSpotsDataByExpId = useCallback(async () => {
    if (!enabled || !experienceId) {
      return
    }

    const { spots, error } = await getSpotsByExperienceId({
      userId: user!.id,
      experienceId,
    })

    if (error || !spots) {
      logger.error(error, 'FetchSpotsByExperience')
      setIsLoading(false)
      return
    }

    setAgamiList(spots)
    setIsLoading(false)
  }, [user, getSpotsByExperienceId, experienceId, enabled])

  useEffect(() => {
    if (!user || !experienceId || enabled === false) {
      return
    }
    fetchSpotsDataByExpId()
  }, [user, experienceId, enabled])

  return { agamiList, isLoading, refetch: fetchSpotsDataByExpId }
}
